import { get } from "lodash";

import tvgConf from "@tvg/conf";
import { getPortByBrand } from "@tvg/utils/generalUtils";

const QUERY_VARIABLES = {
  wagerProfile: "PORT-Generic",
  accountId: ""
};

const POLL_INTERVAL = 60000;

const loggedInOptions = (props) => ({
  ...QUERY_VARIABLES,
  accountId: +get(props, "accountId", "-1"),
  wagerProfile: get(props, "wagerProfile") || getPortByBrand(),
  product: tvgConf().product,
  brand: tvgConf().brand
});

const loggedOutOptions = (props) => ({
  wagerProfile: get(props, "wagerProfile") || getPortByBrand(),
  product: tvgConf().product,
  brand: tvgConf().brand
});

// keeps favorited tracks at the top of the list, preserving relative order otherwise
export const sortFavoritesFirst = (tracks = []) =>
  [...tracks].sort((a, b) => (b.isFavorite ? 1 : 0) - (a.isFavorite ? 1 : 0));

// TODO: Import CombinedHeaderTracksActions
export const topTracksDataFeeder = (tracks = []) =>
  tracks.map((track) => ({
    name: track.name,
    shortName: track.shortName,
    code: track.code,
    isFavorite: track.isFavorite,
    hasPromo: track.hasAboveTheLinePromo || track.hasPromo,
    isFinished: track.isFinished,
    favorite: track.favorite,
    isGreyhound: track.isGreyhound,
    isOpen: false,
    isPromoTagShown: get(track, "isPromoTagShown", false)
  }));

export default {
  options: (props) => {
    const variables = {
      ...(props.isLogged ? loggedInOptions(props) : loggedOutOptions(props))
    };
    return {
      client:
        props.isAccountCompliant && !!get(props, "accountId")
          ? props.rdaClient
          : null,
      pollInterval: POLL_INTERVAL,
      fetchPolicy: "cache-and-network",
      // graph/cosmo only: the favorite field resolver throws per-entity errors for
      // non-favorited tracks instead of returning null; keep the otherwise-valid data
      // those errors would discard. RDA keeps its original errorPolicy untouched, so
      // flipping useRDAService back on fully restores pre-cosmo behavior.
      ...(!props.useRDAService ? { errorPolicy: "all" } : {}),
      ssr: true,
      variables
    };
  },
  props: (result) => {
    const topTracks = get(result, "data.topTracks");

    if (topTracks) {
      // RDA path: untouched, exactly as before the cosmo migration
      return {
        tracks: topTracksDataFeeder(topTracks),
        featuredTracks: topTracksDataFeeder(topTracks),
        isLoading: get(result, "data.loading", false),
        refetch: result.data.refetch
      };
    }

    // graph/cosmo path only: tracks(filter: {featured: true}) only covers the
    // featured half, so favorited-but-not-featured tracks are merged in client-side
    // and favorites are floated to the top
    const featureTracks = get(result, "data.featureTracks", []);
    const favoriteTracks = (get(result, "data.tracks") || []).filter(
      (track) => track.isFavorite
    );
    const tracksByCode = new Map();
    [...featureTracks, ...favoriteTracks].forEach((track) => {
      tracksByCode.set(track.code, track);
    });
    const sortedTracksList = sortFavoritesFirst(
      Array.from(tracksByCode.values())
    );

    return {
      tracks: topTracksDataFeeder(sortedTracksList),
      featuredTracks: topTracksDataFeeder(sortedTracksList),
      isLoading: get(result, "data.loading", false),
      refetch: result.data.refetch
    };
  }
};
